<template>
  <v-card color="grey lighten-4" class="mb-4">
    <v-card-text>
      <v-layout row wrap>
        <v-flex lg12 xs6>
          <div class="infoField">
            <span class="infoLabel">Draft No.:</span>
            <span class="infoValue">{{info.draftNo}}</span>
          </div>
          <div class="infoField">
            <span class="infoLabel">Branch:</span>
            <span class="infoValue">{{info.branch}}</span>
          </div>
          <div class="infoField">
            <span class="infoLabel">Fund:</span>
            <span class="infoValue">{{info.fund}}</span>
          </div>
          <div class="infoField">
            <span class="infoLabel">Insured:</span>
            <span class="infoValue">{{info.insured}}</span>
          </div>
        </v-flex>
        <v-flex lg12 xs6>
          <div class="infoField">
            <span class="infoLabel">Policy Type:</span>
            <span class="infoValue">{{info.polType}}</span>
          </div>
          <div class="infoField">
            <span class="infoLabel">Period of Insurance:</span>
            <span class="infoValue">
              {{formatDate(info.fromDate)}} - {{formatDate(info.endDate)}}
            </span>
          </div>
          <div class="infoField">
            <span class="infoLabel">Underwriting Year:</span>
            <span class="infoValue">{{info.uwYear}}</span>
          </div>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import { formatDisplayDate } from '@/utils/date'
export default {
  methods: {
    formatDate(date) {
      return formatDisplayDate(date)
    }
  },
  props: {
    info: {
      type: Object,
      default: () => {
        return {
          draftNo: '--',
          branch: '--',
          polType: '--',
          fund: '--',
          fromDate: new Date(),
          endDate: new Date(),
          uwYear: 2018,
          insured: 'Wee Kiat, Jeow'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.infoField {
  line-height: 2em;
  .infoLabel {
    vertical-align: top;
    display: inline-block;
    width: 150px;
  }
  .infoValue {
    vertical-align: top;
    display: inline-block;
    font-weight: 500;
    text-align: center;
  }
}
</style>
